/**
 * Ilova qaysi yuzada ochilgan.
 *
 * Amanah bitta ilova: Telegram ham, brauzer ham bitta manzilni
 * (amanah.uz) ochadi, bitta API'dan foydalanadi va bir xil ekranlarni
 * ko'rsatadi. Yuza faqat ikki narsani hal qiladi:
 *
 *   1. Kirish — Telegram'da login yo'q, initData o'zi tanitadi;
 *   2. Chrome — Telegram oynasini to'liq ochish, xavfsiz zona.
 *
 * Ko'rinish esa har ikkalasida bir xil: ekran kengligiga qarab moslashadi.
 */

export type Surface = 'telegram' | 'browser';

/** Telegram WebView ichidamizmi (initData faqat u yerda bo'ladi). */
export function isTelegram(): boolean {
  try {
    return Boolean((window as any).Telegram?.WebApp?.initData);
  } catch {
    return false;
  }
}

export const surface: Surface = isTelegram() ? 'telegram' : 'browser';

/**
 * Telegram oynasini ishga tayyorlash.
 *
 * `ready()` — Telegram'ga "yuklandim" deydi (usiz skelet ko'rinib turadi),
 * `expand()` — oynani to'liq balandlikka ochadi (usiz yarim ekran bo'lib
 * qoladi va ro'yxatlar sig'maydi).
 */
export function initTelegramChrome(): void {
  if (!isTelegram()) return;
  try {
    const webApp = (window as any).Telegram.WebApp;
    webApp.ready();
    webApp.expand();
  } catch {
    // Telegram SDK yo'q yoki eski versiya — ilova baribir ishlayveradi.
  }
}
